import { Box } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { isMixedCreditsEnabled } from '@lingoda/monolith-feature-flags';
import { PromoBanner, PromoBannerHeader } from '../../components/Banners';

const TrialBanner = () => {
    const hasMixedCredits = isMixedCreditsEnabled();

    return (
        <PromoBanner>
            <Box sx={{ maxWidth: '46.25rem' }}>
                <PromoBannerHeader>
                    {trans('trial-banner-title', {}, 'student-store')}
                </PromoBannerHeader>
                {hasMixedCredits
                    ? trans('mixed-credits-trial-banner-subtitle', {}, 'student-store')
                    : trans('trial-banner-subtitle', {}, 'student-store')}
            </Box>
        </PromoBanner>
    );
};

export default TrialBanner;
